<script>
import Dashboard from '@/plugins/dashboard'

export default {
  extends: Dashboard,
  widgets: [],
  data () {
    return {
      breadcrumb: {
        name: 'Dashboard',
        route: { name: 'sales-dashboard' }
      }
    }
  }
}
</script>
